import DataGrid, { Column, Format } from 'devextreme-react/data-grid';
import { useContext } from 'react';
import { useAuth } from '../../../../contexts/auth';
import { CompanyTypes, ProductLine } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { POProduct } from '../types/POProduct';

export default function PurchaseOrderProducts() {

    const { order } = useContext(PurchaseOrderContext);

    const isLaminate = order.details.products.some((p) => {
        return p.productLineID === ProductLine.LaminateInstall || p.productLineID === ProductLine.LaminateDelivered;
    });

    const { user } = useAuth();
    const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;

    return (
        <>
            <div className='dx-card wide-card'>
                <div className='grid-header'>Purchase Order Details</div>
                <DataGrid
                    dataSource={order.details.products}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    showBorders={true}
                    showColumnLines={true}
                    columnAutoWidth={true}
                    wordWrapEnabled={true}
                    keyExpr={'poProductID'}
                    className="grid-with-header"
                >
                    <Column
                        dataField={'productLineDescription'}
                        caption={'Product Line'}
                        dataType="string"
                        visible={!isServiceProvider}
                    />
                    <Column
                        dataField={'sku'}
                        caption={'SKU'}
                        dataType="string"
                    />
                    <Column
                        dataField={'itemDescription'}
                        caption={'Item Description'}
                        dataType="string"
                        encodeHtml={false}
                        calculateDisplayValue={(rowData: POProduct) =>
                            rowData.itemDescription.replace(new RegExp('\\r\\n', 'g'), '<br/>')
                        }
                    />
                    <Column
                        dataField={'thickness'}
                        caption={'Thickness'}
                        dataType="string"
                        visible={!isLaminate && !isServiceProvider}
                    />
                    <Column
                        dataField={'dimensions'}
                        caption={'Dimensions'}
                        dataType="string"
                        visible={!isLaminate && !isServiceProvider}
                    />
                    <Column
                        dataField={'squareFootage'}
                        caption={'Square Footage'}
                        dataType="string"
                        visible={!isLaminate && !isServiceProvider}
                    />
                    <Column
                        dataField={'uom'}
                        caption={'UOM'}
                        dataType="string"
                        visible={!isServiceProvider}
                    />
                    <Column
                        dataField={'qtyOrdered'}
                        caption={'Qty Ordered'}
                        dataType="number"
                    />
                    {
                        !order.details.deliveryFlow &&
                        <Column
                            dataField={'qtyShipped'}
                            caption={!isServiceProvider ? 'Qty Shipped' : 'Qty Initiated'}
                            dataType="number"
                        />
                    }
                    {
                        order.details.deliveryFlow &&
                        <Column
                            dataField={'qtyDelivered'}
                            caption={'Qty Delivered'}
                            dataType="number"
                        />
                    }
                    <Column
                        dataField={'unitCost'}
                        caption={'Unit Cost'}
                        dataType="number"
                    >
                        <Format type="currency" precision={2} ></Format>
                    </Column>
                    <Column
                        dataField={'freightCost'}
                        caption={'Freight Cost'}
                        dataType="number"
                        visible={!isServiceProvider}
                    >
                        <Format type="currency" precision={2} ></Format>
                    </Column>
                    <Column
                        dataField={'totalOrderedCost'}
                        caption={'Total Cost'}
                        dataType="number"
                    >
                        <Format type="currency" precision={2} ></Format>
                    </Column>
                </DataGrid>
            </div>
        </>
    );
}
